<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted montserrat">Images</h6>
            <!-- <vue-picture-swipe :items="items" :options="galleryOptions"></vue-picture-swipe> -->
            <lightbox css="h-200 h-lg-250" :cells="4" :items="items"></lightbox>
            
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import { route, get } from "@utils/network";
import VuePictureSwipe from 'vue-picture-swipe';

export default {
    name: "GallerySection",
    data() {
        return {
            galleryOptions: {
                loop: true,
                closeOnVerticalDrag: true,
                bgOpacity: 0.6,
            },
            items: [],
            shopId: null,
            
        };
    },

    methods: {
        fetchImages() {
            this.isRequesting = true;
            get(route("shops/:id/gallery", { id: this.shopId }))
                .then(response => this.mapImages(response.data.result.gallery))
                .catch(error => {
                    console.log(error);
                    this.promptErrors(error.response.data.message);
                })
                .finally(() => this.isRequesting = false);
        },
        mapImages(images) {
            // this.items = images.map(image => ({
            //         src: image.path,
            //         thumbnail: `${image.path}`,
            //         w: 1200,
            //         h: 900
            // }))
            this.items = images.map(image => `${image.path}`)
        },
        initialize(shopId) {
            this.shopId = shopId
            this.fetchImages();
        }
    },

    mixins: [mixins],
}
</script>
<style lang="css" scoped>
/* @import "https://cdn.jsdelivr.net/npm/morioh@1.0.9/dist/css/morioh.min.css"; */
@import "https://cdn.morioh.net/fa/v5.13.0/css/fontawesome.min.css";
@import "https://cdn.morioh.net/fa/v5.13.0/css/regular.min.css";
@import "https://cdn.jsdelivr.net/npm/animate.css@3.7.2/animate.min.css";
@import "./lightbox.css";
.my-gallery img[itemprop=thumbnail] {
    margin: 10px;
    width: 80px;
}
.lb-modal-close {
    border-width: 0px !important;
}
    
</style>